<p class="results-list__tl baseline" [ngClass]="primaryField.class">{{ primaryField.value }}</p>
@if (!!secondaryField) {
	<p class="results-list__meta-data caption mt-8" [ngClass]="secondaryField.class">
		{{ secondaryField.value }}
	</p>
}
